import { t } from "i18next";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import OrderHeader from "../../components/orderHeader/OrderHeader";
import { useHeader } from "../../contexts/PageHeaderContext";
import "./SplitOrder.scss";
import SplitConfirmation from "./components/splitConfimation/SplitConfirmation";
import TransferItems from "./components/transferItems/TransferItems";

const SplitOrder = () => {
  const { updateHeader, updateSecondHeader } = useHeader();

  const [newSplitDeliveryId, setNewSplitDeliveryId] = useState<string>();
  const [headerItemsAmount, setHeaderItemsAmount] = useState<number>(0);

  const updateHeaders = () => {
    updateHeader(<>{t("splitOrder")}</>);
    updateSecondHeader(null);
  };

  useEffect(() => {
    updateHeaders();
  }, [t]);

  const renderContent = !newSplitDeliveryId ? (
    <TransferItems
      setNewSplitDeliveryId={setNewSplitDeliveryId}
      setHeaderItemsAmount={setHeaderItemsAmount}
    />
  ) : (
    <SplitConfirmation newSplitDeliveryId={newSplitDeliveryId} />
  );

  return (
    <div className="page-content">
      <Helmet title={t("splitOrder")} />
      <OrderHeader
        paddingBottom="16px"
        amount={headerItemsAmount}
        //@ts-ignore
        status={"SPLIT"} //SPLIT is not a real status - but this will not provoke any errors.
      />
      {renderContent}
    </div>
  );
};

export default SplitOrder;
